import React from 'react';

import { FieldComponent } from '@jutro/components';
import _ from 'lodash';
import { SgNumberUtil, SgDateUtil } from 'saga-modules';
import CommonConstants from 'sg-common-constants';

class SgDateInputs extends FieldComponent {
    static propTypes = {
        ...FieldComponent.propTypes
    };

    constructor(props, context) {
        super(props, context);

        this.state = {
            dateChanged: false
        };
    }

    componentDidMount() {
        const {
            id,
            modelVM,
            path,
            onValidate
        } = this.props;

        const date = _.get(modelVM, path).value;
        if (date) {
            date.day = SgDateUtil.formatValue(date.day);
            date.monthViewValue = SgDateUtil.formatValue(date.monthViewValue);
        }

        if (onValidate) {
            onValidate(_.get(modelVM, path).aspects.valid, id);
        }
    }

    componentDidUpdate(prevData) {
        const {
            id,
            modelVM,
            path,
            onValidate,
            value,
            isDateValid
        } = this.props;

        const isValid = _.get(modelVM, path).aspects.valid && _.get(modelVM, path).aspects.subtreeValid;
        const valueChanged = !_.isEqual(value, prevData.value);
        if (onValidate && (valueChanged || (!_.isNil(isDateValid) && !_.isNil(isValid) && isDateValid !== isValid))) {
            onValidate(isValid, id);
        }
    }

    componentWillUnmount() {
        const {
            id,
            onValidate,
        } = this.props;
        onValidate(true, id);
    }

    getValidationMessages() {
        return _.get(this.props.modelVM, `${this.props.path}.aspects.validationMessages`);
    }

    showErrors() {
        return (!_.get(this.props.modelVM, `${this.props.path}.aspects.valid`)
            || !_.get(this.props.modelVM, `${this.props.path}.aspects.subtreeValid`))
            && (this.props.showErrors || this.state.dateChanged);
    }

    onChangeDay = (el) => {
        const date = {
            day: el.target.value || undefined
        };
        this.props.writeValue(date);
    };

    onDayBlur = (el) => {
        if (el.target.value.length === 1) {
            const date = {
                day: `0${el.target.value}`
            };
            this.props.writeValue(date);
        }
    };

    onChangeMonth = (el) => {
        const date = {
            monthViewValue: el.target.value !== '' ? el.target.value : undefined,
            month: el.target.value !== '' ? Number.parseInt(el.target.value, 10) - 1 : undefined
        };
        this.props.writeValue(date);
    };

    onMonthBlur = (el) => {
        if (el.target.value.length === 1) {
            const date = {
                month: Number.parseInt(el.target.value, 10) - 1,
                monthViewValue: `0${el.target.value}`
            };
            this.props.writeValue(date);
        }
    };

    onChangeYear = (el) => {
        const date = {
            year: el.target.value !== '' ? el.target.value : undefined
        };
        this.props.writeValue(date);
    };

    onYearBlur = (el) => {
        if (this.props.autoCompleteYear && el.target.value.length === 2 && SgNumberUtil.numbersOnly(el.target.value)) {
            const date = {
                year: '19'.concat(el.target.value)
            };
            this.props.writeValue(date);
        }
        this.setState({ dateChanged: true });
    };

    // restrict keys on date fields to numbers and standard interaction only
    filterKeyPress = (event) => {
        const charCode = event.which ? event.which : event.keyCode;
        const key = Number(event.key);
        if (charCode >= CommonConstants.EVENT_KEYS.LETTERS_AND_NUMBERS_RANGE_START && Number.isNaN(key)) {
            event.preventDefault();
        }
    };

    renderControl() {
        const {
            customId
        } = this.props;
        return (
            <div className="sg-day-month-year-inputs-container">
                {!this.props.hideDay
                    && (
                        <input
                            id={`${customId}Day`}
                            type="tel"
                            value={(this.props.value && this.props.value.day) || ''}
                            onChange={this.onChangeDay}
                            onBlur={this.onDayBlur}
                            disabled={this.props.disabled}
                            placeholder="DD"
                            maxLength="2"
                            onKeyDown={this.filterKeyPress}
                        />
                    )
                }
                <input
                    id={`${customId}Month`}
                    type="tel"
                    value={(this.props.value && this.props.value.monthViewValue) || ''}
                    onChange={this.onChangeMonth}
                    onBlur={this.onMonthBlur}
                    disabled={this.props.disabled}
                    placeholder="MM"
                    maxLength="2"
                    onKeyDown={this.filterKeyPress}
                />
                <input
                    id={`${customId}Year`}
                    type="tel"
                    value={(this.props.value && this.props.value.year) || ''}
                    onChange={this.onChangeYear}
                    onBlur={this.onYearBlur}
                    disabled={this.props.disabled}
                    placeholder="YYYY"
                    maxLength="4"
                    onKeyDown={this.filterKeyPress}
                />
            </div>
        );
    }

    render() {
        return super.render();
    }
}

export default SgDateInputs;
